export default __webpack_public_path__ + "953f1021e2dd0d7845d9eada049a0c3b.svg";